import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var partElements = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Service type:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ServiceTypeName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Rate(₹):',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Rate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW !== void 0 && _formData$SavedPriceW.Rate) {
                                var _formData$SavedPriceW2, _formData$SavedPriceW3;
                                var rate = formData !== null && formData !== void 0 && (_formData$SavedPriceW2 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW2 !== void 0 && _formData$SavedPriceW2.Rate ? formData === null || formData === void 0 || (_formData$SavedPriceW3 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW3 === void 0 ? void 0 : _formData$SavedPriceW3.Rate : '-';
                                return rate;
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'Quantity',
                        children: 'Quantity:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Quantity',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW4;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW4 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW4 !== void 0 && _formData$SavedPriceW4.Quantity) {
                                var _formData$SavedPriceW5, _formData$SavedPriceW6;
                                var Quantity = formData !== null && formData !== void 0 && (_formData$SavedPriceW5 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW5 !== void 0 && _formData$SavedPriceW5.Quantity ? formData === null || formData === void 0 || (_formData$SavedPriceW6 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW6 === void 0 ? void 0 : _formData$SavedPriceW6.Quantity : '-';
                                return Quantity;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'UOM',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'UnitOfMeasurementName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Discount:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'DiscountAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW7;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW7 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW7 !== void 0 && _formData$SavedPriceW7.Discount) {
                                var _formData$SavedPriceW8, _formData$SavedPriceW9;
                                var Discount = formData !== null && formData !== void 0 && (_formData$SavedPriceW8 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW8 !== void 0 && _formData$SavedPriceW8.Discount ? formData === null || formData === void 0 || (_formData$SavedPriceW9 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW9 === void 0 ? void 0 : _formData$SavedPriceW9.Discount : '-';
                                return Discount;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Taxable amount (₹):',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'TaxableAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW10;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW10 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW10 !== void 0 && _formData$SavedPriceW10.TaxableAmount) {
                                var _formData$SavedPriceW11, _formData$SavedPriceW12;
                                var taxableAmount = formData !== null && formData !== void 0 && (_formData$SavedPriceW11 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW11 !== void 0 && _formData$SavedPriceW11.TaxableAmount ? formData === null || formData === void 0 || (_formData$SavedPriceW12 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW12 === void 0 ? void 0 : _formData$SavedPriceW12.TaxableAmount : '-';
                                return taxableAmount;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'CGST:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'CGSTAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW13, _cgst$TaxComponentAmo;
                            var cgst = formData === null || formData === void 0 || (_formData$SavedPriceW13 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW13 === void 0 || (_formData$SavedPriceW13 = _formData$SavedPriceW13.Taxes) === null || _formData$SavedPriceW13 === void 0 ? void 0 : _formData$SavedPriceW13.find(function (tax) { return tax.TaxComponentName === 'CGST'; });
                            return (_cgst$TaxComponentAmo = cgst === null || cgst === void 0 ? void 0 : cgst.TaxComponentAmount) !== null && _cgst$TaxComponentAmo !== void 0 ? _cgst$TaxComponentAmo : 0;
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'SGST:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'SGST_UTGST_Amount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW14, _cgst$TaxComponentAmo2;
                            var cgst = formData === null || formData === void 0 || (_formData$SavedPriceW14 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW14 === void 0 || (_formData$SavedPriceW14 = _formData$SavedPriceW14.Taxes) === null || _formData$SavedPriceW14 === void 0 ? void 0 : _formData$SavedPriceW14.find(function (tax) { return tax.TaxComponentName === 'IGST'; });
                            return (_cgst$TaxComponentAmo2 = cgst === null || cgst === void 0 ? void 0 : cgst.TaxComponentAmount) !== null && _cgst$TaxComponentAmo2 !== void 0 ? _cgst$TaxComponentAmo2 : 0;
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Total amt.(₹) :',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Amount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW15;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW15 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW15 !== void 0 && _formData$SavedPriceW15.Amount) {
                                var _formData$SavedPriceW16, _formData$SavedPriceW17;
                                var Amount = formData !== null && formData !== void 0 && (_formData$SavedPriceW16 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW16 !== void 0 && _formData$SavedPriceW16.Amount ? formData === null || formData === void 0 || (_formData$SavedPriceW17 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW17 === void 0 ? void 0 : _formData$SavedPriceW17.Amount : '-';
                                return Amount;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }]
    }];
export var labourElements = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Service type:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ServiceTypeName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Rate(₹):',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Rate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW18;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW18 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW18 !== void 0 && _formData$SavedPriceW18.Rate) {
                                var _formData$SavedPriceW19, _formData$SavedPriceW20;
                                var rate = formData !== null && formData !== void 0 && (_formData$SavedPriceW19 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW19 !== void 0 && _formData$SavedPriceW19.Rate ? formData === null || formData === void 0 || (_formData$SavedPriceW20 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW20 === void 0 ? void 0 : _formData$SavedPriceW20.Rate : '-';
                                return rate;
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'Quantity',
                        children: 'Quantity:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Quantity',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW21;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW21 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW21 !== void 0 && _formData$SavedPriceW21.Quantity) {
                                var _formData$SavedPriceW22, _formData$SavedPriceW23;
                                var Quantity = formData !== null && formData !== void 0 && (_formData$SavedPriceW22 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW22 !== void 0 && _formData$SavedPriceW22.Quantity ? formData === null || formData === void 0 || (_formData$SavedPriceW23 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW23 === void 0 ? void 0 : _formData$SavedPriceW23.Quantity : '-';
                                return Quantity;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'UOM',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'UnitOfMeasurementName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Discount:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'DiscountAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW24;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW24 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW24 !== void 0 && _formData$SavedPriceW24.Discount) {
                                var _formData$SavedPriceW25, _formData$SavedPriceW26;
                                var Discount = formData !== null && formData !== void 0 && (_formData$SavedPriceW25 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW25 !== void 0 && _formData$SavedPriceW25.Discount ? formData === null || formData === void 0 || (_formData$SavedPriceW26 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW26 === void 0 ? void 0 : _formData$SavedPriceW26.Discount : '-';
                                return Discount;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Taxable amount (₹):',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'TaxableAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW27;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW27 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW27 !== void 0 && _formData$SavedPriceW27.TaxableAmount) {
                                var _formData$SavedPriceW28, _formData$SavedPriceW29;
                                var taxableAmount = formData !== null && formData !== void 0 && (_formData$SavedPriceW28 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW28 !== void 0 && _formData$SavedPriceW28.TaxableAmount ? formData === null || formData === void 0 || (_formData$SavedPriceW29 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW29 === void 0 ? void 0 : _formData$SavedPriceW29.TaxableAmount : '-';
                                return taxableAmount;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'CGST:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'CGSTAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW30, _cgst$TaxComponentAmo3;
                            var cgst = formData === null || formData === void 0 || (_formData$SavedPriceW30 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW30 === void 0 || (_formData$SavedPriceW30 = _formData$SavedPriceW30.Taxes) === null || _formData$SavedPriceW30 === void 0 ? void 0 : _formData$SavedPriceW30.find(function (tax) { return tax.TaxComponentName === 'CGST'; });
                            return (_cgst$TaxComponentAmo3 = cgst === null || cgst === void 0 ? void 0 : cgst.TaxComponentAmount) !== null && _cgst$TaxComponentAmo3 !== void 0 ? _cgst$TaxComponentAmo3 : 0;
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'SGST:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'SGST_UTGST_Amount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW31, _cgst$TaxComponentAmo4;
                            var cgst = formData === null || formData === void 0 || (_formData$SavedPriceW31 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW31 === void 0 || (_formData$SavedPriceW31 = _formData$SavedPriceW31.Taxes) === null || _formData$SavedPriceW31 === void 0 ? void 0 : _formData$SavedPriceW31.find(function (tax) { return tax.TaxComponentName === 'IGST'; });
                            return (_cgst$TaxComponentAmo4 = cgst === null || cgst === void 0 ? void 0 : cgst.TaxComponentAmount) !== null && _cgst$TaxComponentAmo4 !== void 0 ? _cgst$TaxComponentAmo4 : 0;
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Total amt.(₹) :',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Amount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            var _formData$SavedPriceW32;
                            if (formData !== null && formData !== void 0 && (_formData$SavedPriceW32 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW32 !== void 0 && _formData$SavedPriceW32.Amount) {
                                var _formData$SavedPriceW33, _formData$SavedPriceW34;
                                var Amount = formData !== null && formData !== void 0 && (_formData$SavedPriceW33 = formData.SavedPriceWithTax) !== null && _formData$SavedPriceW33 !== void 0 && _formData$SavedPriceW33.Amount ? formData === null || formData === void 0 || (_formData$SavedPriceW34 = formData.SavedPriceWithTax) === null || _formData$SavedPriceW34 === void 0 ? void 0 : _formData$SavedPriceW34.Amount : '-';
                                return Amount;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }]
    }];
